import "../../styles/style"
import "../../cell/style"
import "../index.scss"
